<template>
  <!--  页面头部-->
  <div class="header-box">

  </div>
</template>

<script>

export default {
  name: "siteNav",
  data() {
    return{

    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/siteNav.vue